<template>
  <div class="stform personapply" v-if="personapply">
    <div class="pagePopMask pFull" @click.self="closePop"></div>
    <div class="pagePop w1280 pCenter">
      <div class="w">
        <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.person_apply_record }}</div>

        <div class="cont">
          <div class="compCommonInfo fnt_18">
            <span class="w50">{{ globalDataArray.siteTemplateLanguage.team_name }}：{{ datainfo.teamName }}</span>
            <span class="w50">{{ globalDataArray.siteTemplateLanguage.team_type }}：{{ datainfo.teamType_dictText }}</span>
          </div>

          <div class="pad_0_16">
            <TeamMemberInfo :user-info-array="teamMemberList"/>
          </div>
        </div>
        <div class="close" @click.self="closePop"></div>
      </div>
    </div>
  </div>
</template>

<script>
import TeamMemberInfo from '@/views/person/component/TeamMemberInfo.vue'

export default {
  name: 'Personapply',
  components: { TeamMemberInfo },
  props: {
    personapply: {
      type: Boolean,
      default: false
    },
    curid: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      datainfo: {
        teamName: '',
        teamType: '',
        userName: '',
        userPhone: '',
        userMail: '',
        companyType: '',
        company: '',
        jobType: '',
        countryName: '',
        countryCode: '',
        cityName: '',
        cityCode: '',
        templateId: '',
        nation: ''
      },
      teamMemberList: []
    }
  },
  watch: {
    curid: {
      immediate: true,
      handler(record) {
        if (record != '') {
          this.applyRecord(record)
          // 获取信息
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    applyRecord(record) {
      this.datainfo = record
      this.templateId = record.templateId
      this.nation = record.nation
      if (record.sigupJson) {
        this.teamMemberList = JSON.parse(record.sigupJson)
      }
      console.log(this.datainfo, 'dateinfo')
    },
    closePop() {
      this.$emit('update:personapply', false)
    }
  }
}
</script>
